import { render, staticRenderFns } from "./MiniSuborders.vue?vue&type=template&id=5a0b4b86&"
import script from "./MiniSuborders.vue?vue&type=script&lang=js&"
export * from "./MiniSuborders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports